import Vue from 'vue'
import request from '@/helpers/request'
import fullName from '@/helpers/full_name'
import router from '@/router'
import ServerValidationError from '@/helpers/ServerValidationError'
import snack from '@/helpers/snack'
import { GET_CUSTOMERS } from '@/store/action_types'
import _ from 'lodash'

const MAX_NAME_LENGTH = 30

const customersAll = payload => {
  return axios.get(`${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`, { params: payload })
}

export default {
  [GET_CUSTOMERS]({ commit, state }, { params = {}, formatter, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`,
      {
        params: params,
      },
      true,
    ).then(({ data }) => {
      if (data.result === 'success') {
        let customers = data.data.items
        if (formatter) {
          customers = formatter(customers)
        }

        commit('setCustomers', state.customers.concat(customers))
        commit('setCustomerFilters', data.data.filters)
        commit('setCustomersCounter', data.data.count)
        callback ? callback() : null
      }
    })
  },
  GET_CUSTOMERS: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      customersAll(payload)
        .then(
          ({
            data: {
              data: { items, count },
            },
          }) => {
            items.forEach((el, i) => {
              items[i].full_name = fullName.by(items[i], undefined, true)
            })

            commit('setCustomers', items)
            resolve(count)
          },
        )
        .catch((error, response) => {
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  GET_CUSTOMERS_WITH_RESET: ({ commit, state }, payload) => {
    return customersAll(payload).then(({ data: { data } }) => {
      commit('setCustomers', data.items)
      commit('setCustomersCount', data.count)
      commit('setCustomerFilters', data.filters)
    })
  },
  GET_CUSTOMER({ commit, state }, customerID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.one.replace('$1', customerID)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const customer = response.data.data
        commit('setCustomer', customer)
        commit('setTitle', fullName.by(state.customer, MAX_NAME_LENGTH))
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  UPDATE_CUSTOMER: ({ commit, state }) => {
    commit('setLoad', true)

    const params = {
      first_name: state.customer.first_name,
      last_name: state.customer.last_name,
      middle_name: state.customer.middle_name,
      email: state.customer.email,
      phone: state.customer.phone,
      phone_code: state.customer.phone_code,
      comment: state.customer.comment,
      confirm_email: state.customer.confirm_email,
      confirm_sms: state.customer.confirm_sms,
      user_source_id: state.customer.user_source_id,
      country_id: state.customer.country_id,
      city_id: state.customer.city_id,
      is_blocked: state.customer.is_blocked,
      birth_date: state.customer.birth_date,
    }
    if (params.phone.search(/[*]+/) != -1) {
      delete params.phone
    }
    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.one.replace('$1', state.customer.id)}`,
      params,
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          commit('changeCustomer', { key: state.customer.id, value: state.customer })
          commit('setTitle', fullName.by(state.customer, MAX_NAME_LENGTH))
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },
  CREATE_CUSTOMER: ({ commit, state }) => {
    commit('setLoad', true)
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`,
      {
        first_name: state.customer.first_name,
        last_name: state.customer.last_name,
        middle_name: state.customer.middle_name,
        email: state.customer.email,
        phone: state.customer.phone,
        comment: state.customer.comment,
        confirm_email: state.customer.confirm_email,
        confirm_sms: state.customer.confirm_sms,
        user_source_id: state.customer.user_source_id,
        country_id: state.customer.country_id,
        city_id: state.customer.city_id,
        is_blocked: state.customer.is_blocked,
        birth_date: state.customer.birth_date,
      },
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data

          commit('setCustomerField', { key: 'id', value: data.id })
          commit('setTitle', fullName.by(state.customer, MAX_NAME_LENGTH))
          commit('unshiftCustomers', { ...state.customer })

          router.push({ path: Vue.config.modules.crm.route.customers.one.replace('$1', data.id) })
          commit('setLoad', false)

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.savedMessage,
          })
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },
  CREATE_CUSTOMER_IN_MODAL: ({ commit, state }, currentTab) => {
    commit('setLoad', true)

    const newCustomer = () => {
      const obj = _.cloneDeep(state.customer)
      const propNames = Object.getOwnPropertyNames(obj)
      for (let i = 0; i < propNames.length; i++) {
        const propName = propNames[i]
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] == '') {
          delete obj[propName]
        }
      }
      return obj
    }
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`, newCustomer(), true).then(
      response => {
        if (response.data.result === 'success') {
          const customer = response.data.data
          // create customer in modal
          const firstName = customer.first_name ? customer.first_name : ''
          const lastName = customer.last_name ? customer.last_name : ''
          const phone = customer.phone ? customer.phone.substr(-4) || '' : ''
          customer.name = `${firstName} ${lastName} ${phone}`

          commit('setLoad', false)
          commit('setSelectedUser', { data: customer, currentTab: currentTab })
          commit('addUserToUsers', { user: customer })
          snack.add('Клиент успешно создан', 'primary')
          commit('setNewUserModal', false)
        } else {
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
        commit('setLoad', false)
      },
    )
  },
  DELETE_CUSTOMER: async ({ commit, state }) => {
    await request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.one.replace('$1', state.customer.id)}`,
      {},
      true,
    ).then(
      response => {
        if (response.data.result === 'success') {
          const date = new Date()
          commit('setCustomerField', { key: 'deleted_at', value: date })

          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'success',
            text: Vue.config.localization.ru.deleteMessage,
          })
        } else {
          Vue.notify({
            group: 'hasBottomNavigation',
            title: '',
            type: 'error',
            text: Vue.config.localization.ru.notFoundMessage,
          })
          // TODO: Show error dialog
        }
      },
      e => {
        ServerValidationError.notify(e, 'customerValidation')
      },
    )
  },
  RESTORE_CUSTOMER: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request(
        'PATCH',
        `${Vue.config.server}/${Vue.config.modules.crm.api.customers.one.replace('$1', state.customer.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('setCustomerField', { key: 'deleted_at', value: null })

          snack.add(Vue.config.localization.ru.successRestore, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorRestoreMessage)
        }
      })

      resolve()
    })
  },
  GET_CUSTOMER_WITH_CUSTOMERS({ commit, state }, customerID) {
    commit('setLoad', true)

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.one.replace('$1', customerID)}`,
      {
        params: {
          with: 'clubCard;avatar',
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const customer = response.data.data
          commit('setCustomer', customer)
          commit('setTitle', fullName.by(customer))

          // Get customers
          return request(
            'GET',
            `${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`,
            {
              params: {
                offset: 0,
                limit: 30,
              },
            },
            true,
          )
        } else {
          // TODO: Show error dialog
        }
      })
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setCustomers', state.customers.concat(data.items))
          commit('setCustomerFilters', data.filters)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      })
  },
  GET_NEW_CUSTOMER_DATA: ({ commit, state }) => {
    commit('setLoad', true)

    // Get customers
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.customers.all}`,
      {
        params: {
          offset: 0,
          limit: 30,
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setCustomers', state.customers.concat(data.items))
        commit('setCustomerFilters', data.filters)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_BOOKINGS_FROM_CUSTOMER: ({ commit, state }, { params, callback }) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookings.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setCustomerBookings', data.items)

        if (callback) {
          callback(data.items)
        }
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_LOGS_FROM_CUSTOMER: ({ commit, state }, params) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.audits.all}`,
      {
        params: params.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setCustomerLogs', data.items)
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SIP_HISTORY_FOR_CUSTOMER: ({ commit, state }, payload) => {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.sipHistory.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const history = response.data.data
        history.reverse()
        commit('setCustomerSipHistory', history)
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
